var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourseLibrary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 62,
    viewBox: "0 0 63 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_132_529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.7353 48.0286L44.7329 21.598C44.5945 21.2335 44.3858 20.8998 44.1185 20.6161C43.8512 20.3323 43.5306 20.104 43.1751 19.9441C42.8195 19.7842 42.436 19.696 42.0463 19.6844C41.6566 19.6728 41.2685 19.7381 40.9041 19.8765L36.2145 21.6425V17.2943C36.2145 16.5386 35.9143 15.8138 35.38 15.2795C34.8456 14.7451 34.1209 14.4449 33.3652 14.4449H25.8263V11.3581C25.8263 10.6024 25.5261 9.8777 24.9918 9.34334C24.4574 8.80899 23.7327 8.50879 22.977 8.50879H12.47C11.6828 8.50879 10.9279 8.82149 10.3713 9.37811C9.81466 9.93473 9.50195 10.6897 9.50195 11.4769V51.5457C9.50195 51.9393 9.65831 52.3168 9.93662 52.5951C10.2149 52.8734 10.5924 53.0298 10.986 53.0298H34.7305C35.1241 53.0298 35.5016 52.8734 35.7799 52.5951C36.0582 52.3168 36.2145 51.9393 36.2145 51.5457V32.654L43.6347 52.2581C43.7039 52.4403 43.8082 52.6071 43.9419 52.749C44.0755 52.8909 44.2358 53.0051 44.4136 53.085C44.5914 53.1649 44.7832 53.209 44.978 53.2148C45.1728 53.2206 45.3669 53.188 45.5491 53.1188L53.8745 49.943C54.0568 49.8738 54.2236 49.7694 54.3655 49.6358C54.5073 49.5021 54.6215 49.3418 54.7014 49.1641C54.7814 48.9863 54.8255 48.7945 54.8313 48.5997C54.8371 48.4048 54.8045 48.2108 54.7353 48.0286ZM22.8582 17.1607V50.0617H12.47V11.4769H22.8582V17.1607ZM33.2465 50.0617H25.8263V17.413H33.2465V50.0617ZM45.8756 49.6907L36.4075 24.7144L41.9577 22.6071L51.4407 47.5834L45.8756 49.6907Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_132_529"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseLibrary);
export default __webpack_public_path__ + "static/media/course-library.802e9b1c8d2e5538c0dca745e656842a.svg";
export { ForwardRef as ReactComponent };